'use client';

import { useState, useEffect } from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

const GuestBrowseLink = () => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  if (!isHydrated) {
    return (
      <div className="w-full max-w-md mx-auto mt-6">
        <div className="h-12 bg-muted rounded animate-pulse"></div>
      </div>
    );
  }

  return (
    <div className="w-full max-w-md mx-auto mt-6">
      <Link
        href="/home-dashboard"
        className="flex items-center justify-center gap-2 w-full px-4 py-3 bg-muted text-foreground rounded-md font-medium text-sm transition-smooth hover:bg-border hover:shadow-elevation-sm"
      >
        <Icon name="EyeIcon" size={18} />
        <span>Continue as Guest</span>
      </Link>
      <p className="mt-2 text-xs text-center text-muted-foreground">
        Browse products without logging in. Login required for orders.
      </p>
    </div>
  );
};

export default GuestBrowseLink;